import { render, staticRenderFns } from "./view-metal.vue?vue&type=template&id=4487d306&scoped=true&"
import script from "./view-metal.vue?vue&type=script&lang=js&"
export * from "./view-metal.vue?vue&type=script&lang=js&"
import style0 from "./view-metal.vue?vue&type=style&index=0&id=4487d306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487d306",
  null
  
)

export default component.exports